import { useCallback, useMemo } from "react";

import type { ISwSettings } from "app/@types/ISwSettings";
import { swSettings } from "app/common/services/swSettings";
import type { AeoCampaignType } from "app/components/AeoCampaignModal/utils/campaignTypes";
import { getAeoCampaignType } from "app/components/AeoCampaignModal/utils/campaignTypes";
import { getPackageHrefWithPromoCode } from "app/components/discountCampaign/DiscountBanner/utils/getPackageHrefWithPromoCode";
import { getUserPlan } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

import type { IModalProps } from "../hooks/useDiscounts";
import { useDiscounts } from "../hooks/useDiscounts";

import { AEO_PROMO_CODES, AEO_PROMO_CODES_WITH_UPGRADE_TO_ANNUAL } from "./configs/aeoCampaignConfig";

interface IUseAeoCampaignAPI {
    hasAeoCta: boolean;
    aeoCtaType: AeoCampaignType | null;
    onAeoCtaClick: () => void;
    discountModalProps: IModalProps | null;
}

export const useAeoCampaign = (): IUseAeoCampaignAPI => {
    const { hasDiscountCampaign, discountModalProps } = useDiscounts();

    const aeoCtaType = useMemo((): AeoCampaignType | null => {
        if (!hasDiscountCampaign) {
            return null;
        }
        return getAeoCampaignType(getUserPlan(swSettings as ISwSettings));
    }, [hasDiscountCampaign]);

    const onAeoCtaClick = useCallback(() => {
        if (!aeoCtaType) {
            return;
        }
        const promoCode = AEO_PROMO_CODES[aeoCtaType];
        window.open(getPackageHrefWithPromoCode(promoCode, AEO_PROMO_CODES_WITH_UPGRADE_TO_ANNUAL));
    }, [aeoCtaType]);

    return {
        hasAeoCta: aeoCtaType !== null,
        aeoCtaType,
        onAeoCtaClick,
        discountModalProps,
    };
};
